import APIService from "./API.service";

class FileService extends APIService {
  // Upload image file
  uploadImageFile(
    resource: string,
    params: { resourceId: number; file: File }
  ) {
    const token = localStorage.getItem("fielddrive-token");
    const formData = new FormData();
    formData.append("file", params.file);

    return this.call.post(
      `${this.apiUrl}/file/uploadimage?id=${params.resourceId}&category=${resource}&token=${token}`,
      formData
    );
  }

  // Upload CSV file
  uploadCSVFile(eventId: number, fileName: string, file: File) {
    const token = localStorage.getItem("fielddrive-token");
    const formData = new FormData();
    formData.append("file", file);
    return this.call.post(
      `${this.apiUrl}/file/uploadcsv?id=${eventId}&fileName=${fileName}&token=${token}`,
      formData
    );
  }

  // Upload CSV file
  uploadLogProcess(eventId: number, fileName: string, file: any) {
    const token = localStorage.getItem("fielddrive-token");
    const formData = new FormData();

    // Append file and additional fields to formData
    formData.append("file", file);
    return this.call.post(
      `${this.apiUrl}/file/uploadActionLog?eventId=${eventId}&subfolder=${null}&fileName=${fileName}&token=${token}`, formData
    );
  }
}

export default FileService;
